import React from "react";
import MotionModal from "@/components/atomics/motion-modal";
import UploadAvatar from "@/components/atomics/upload-avatar";
import { InfoModal } from "@/components/atomics/info-modal";
import { ModalState, OwnerState, ViewState } from "@/types/owner-edit";

interface OwnerModalsProps {
  modalState: ModalState;
  ownerData: OwnerState;
  address: string;
  viewState: ViewState;
  onUpdateAvatar: (
    file: File | string,
    nftNumber: string | null,
    index?: number
  ) => void;
  onUpdateBackground: (
    file: File | string,
    nftNumber: string | null,
    index?: number
  ) => void;
  onCloseAvatarModal: () => void;
  onCloseBackgroundModal: () => void;
  onCloseReportModal: () => void;
}

const OwnerModals: React.FC<OwnerModalsProps> = ({
  modalState,
  ownerData,
  address,
  viewState,
  onUpdateAvatar,
  onUpdateBackground,
  onCloseAvatarModal,
  onCloseBackgroundModal,
  onCloseReportModal,
}) => {
  return (
    <>
      <MotionModal
        isOpen={modalState.showAvatarModal}
        className="fixed left-0 right-0 mx-auto top-0 max-w-[430px] w-[100vw] h-[100vh] bg-black flex justify-center z-[999] overflow-y-auto scrollbar-hide"
      >
        <UploadAvatar
          title="AVATAR"
          onAvatarChange={(file, nftNumber, index) => {
            onUpdateAvatar(file, nftNumber, index);
            onCloseAvatarModal();
          }}
          onClose={onCloseAvatarModal}
        />
      </MotionModal>

      <MotionModal
        isOpen={modalState.showBackgroundModal}
        className="fixed left-0 right-0 mx-auto top-0 max-w-[430px] w-[100vw] h-[100vh] bg-black flex justify-center z-[999] overflow-y-auto scrollbar-hide"
      >
        <UploadAvatar
          title="BACKGROUND"
          onAvatarChange={(file, nftNumber, index) => {
            onUpdateBackground(file, nftNumber, index);
            onCloseBackgroundModal();
          }}
          onClose={onCloseBackgroundModal}
        />
      </MotionModal>

      <MotionModal isOpen={modalState.showReportModal}>
        <InfoModal
          onClose={onCloseReportModal}
          ownerData={ownerData}
          address={address}
          viewState={viewState}
        />
      </MotionModal>
    </>
  );
};

export default OwnerModals;
